<template>
  <div class="categoryList">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-4 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <card no-body body-classes="px-0 pb-1" footer-classes="pb-2">
        <div slot="header" class="row align-items-center">
          <div class="col-lg-9 col-8">
            <h3 class="mb-0">Channel Categories</h3>
          </div>
          <div class="col-lg-3 pull-left">
            <button class="btn btn-vobo opacity-8 float-right" @click="openCategoryForm">
              <i class="fa fa-plus-circle"></i>
              Add Category
            </button>
          </div>
        </div>

        <b-row>
          <div class="col-lg-12 col-md-12 col-12">
            <b-card no-body>
              <b-card-body>
                <b-row>
                  <div class="col-lg-12 col-md-12 col-12">
                    <div class="col-lg-3 pull-right no-gutters">
                      <base-input v-model="searchRequest" prepend-icon="fas fa-search" placeholder="Search"></base-input>
                    </div>
                  </div>
                </b-row>
                <b-row v-if="loading">
                  <div class="col-lg-12 text-center">
                    <pulse-loader :color="'#3867d6'"></pulse-loader>
                  </div>
                </b-row>
                <b-table
                  v-if="!loading"
                  id="categoryTable"
                  v-model:sort-by="sortBy"
                  v-model:sort-desc="sortDesc"
                  class="categoryTable"
                  responsive
                  hover
                  :items="cpCategories"
                  :fields="ListFields"
                  :filter="searchRequest"
                  :current-page="currentPage"
                  :per-page="perPage"
                  head-variant="light"
                  @filtered="onSearch">
                  <div slot="category" slot-scope="item" class="data">
                    <span class="title text-break-all">{{ item.item.category }}</span>
                  </div>
                  <div slot="group" slot-scope="item" class="data">
                    <span class="title text-break-all" v-html="getGroupNames(item.item.cpGroups)"> </span>
                    <b-modal :id="`groupInfo${item.item.groupCount}`" ref="groupModal" title="User Groups" centered scrollable :header-text-variant="'gray'">
                      <div class="d-block text-center groupInfo">
                        <div v-if="getGroups(item.item.cpGroups).length > 0">
                          <h4>Selected Groups</h4>
                          <table class="table table-bordered table-striped groupTable">
                            <thead>
                              <tr>
                                <th>Group Name</th>
                                <th>Add</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(group, indexGroup) in getGroups(item.item.cpGroups)" :key="indexGroup">
                                <td
                                  :class="{
                                    selectedGroupsBody: getGroups(item.item.cpGroups).length > 0 && getGroups(item.item.cpGroups).length === indexGroup + 1,
                                  }">
                                  {{ group.name }}
                                </td>
                                <td
                                  :class="{
                                    selectedGroupsBody: getGroups(item.item.cpGroups).length > 0 && getGroups(item.item.cpGroups).length === indexGroup + 1,
                                  }">
                                  <div class="custom-control custom-checkbox">
                                    <input
                                      :id="`group${group.id}`"
                                      type="checkbox"
                                      :checked="checkGroupIfExist(item.item.cpGroups, group.id)"
                                      aria-hidden="true"
                                      class="custom-control-input"
                                      :value="group.id"
                                      @click="selectGroup(item.item.actions.id, group.id)" />
                                    <label :for="`group${group.id}`" class="custom-control-label"> </label>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <br />
                        </div>
                        <table v-if="groupForCategories.length > 0" class="table table-bordered table-striped groupTable">
                          <thead>
                            <tr>
                              <th>Group Name</th>
                              <th>Add</th>
                            </tr>
                          </thead>

                          <tbody v-for="(group, index) in groupForCategories" :key="index">
                            <tr v-if="!checkGroupIfExist(item.item.cpGroups, group._id)">
                              <td>{{ group.group }}</td>
                              <td>
                                <div class="custom-control custom-checkbox">
                                  <input
                                    :id="`group${group._id}`"
                                    type="checkbox"
                                    :checked="checkGroupIfExist(item.item.cpGroups, group._id)"
                                    aria-hidden="true"
                                    class="custom-control-input"
                                    :value="group._id"
                                    @click="selectGroup(item.item.actions.id, group._id)" />
                                  <label :for="`group${group._id}`" class="custom-control-label"> </label>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div v-else>No Channel Group Added Yet. Please add group in Channels > Groups</div>
                      </div>
                      <template #modal-footer>
                        <div class="row px-0 mx-0 w-100">
                          <div class="col-lg-12 col-md-12 col-12 no-gutters">
                            <button
                              v-promise-btn="{ minTimeout: 1500 }"
                              type="button"
                              :disabled="changedLength"
                              class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
                              @click="processUserGroup(item.item.actions.id)">
                              Save
                            </button>
                          </div>
                        </div>
                      </template>
                    </b-modal>
                  </div>
                  <div slot="companyID" slot-scope="item" class="data text-center">
                    <span class="title text-break-all">{{ item.item.companyID }}</span>
                  </div>
                  <div slot="dateCreated" slot-scope="item" class="data">
                    <span class="title text-break-all">{{ item.item.dateCreated }}</span>
                  </div>
                  <div slot="status" slot-scope="item" class="data text-center">
                    <span class="title text-break-all">
                      <span :class="item.item.status.statusClass" class="badge badge-pill text-white">{{ item.item.status.status }}</span>
                    </span>
                  </div>
                  <div slot="actions" slot-scope="item" class="data">
                    <router-link
                      v-b-tooltip.hover
                      :to="`/content-provider/categories/edit/${item.item.actions.id}`"
                      title="Edit Category"
                      class="btn btn-outline-primary btn-sm">
                      <span class="btn-inner--icon"><i class="far fa-edit"></i> </span>
                    </router-link>
                    <a
                      v-b-tooltip.hover
                      title="Delete Category"
                      class="btn btn-outline-danger btn-sm text-danger"
                      @click="deleteProcess(item.item.actions.id, item.item.category)">
                      <span class="btn-inner--icon"><i class="far fa-trash-alt"></i> </span>
                    </a>
                    <a
                      id="show-btn"
                      v-b-tooltip.hover
                      class="btn btn-outline-vobo btn-sm text-vobo"
                      title="Show Groups"
                      @click="getGroupList(item.item.groupCount)">
                      <span class="btn-inner--icon"><i class="fas fa-users"></i> </span>
                    </a>
                  </div>
                </b-table>
                <b-row v-if="cpCategories.length === 0 && !loading">
                  <b-col sm="12">
                    <h4 v-if="selectedCompany === undefined" class="card-heading text-center">Please Select Organization First</h4>
                    <h4 v-else class="card-heading text-center">No records found</h4>
                  </b-col>
                </b-row>
                <b-pagination
                  v-if="totalRows > 10"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                  align="center"
                  @change="updateCurrentPage" />
                <div v-if="totalRows > 10 && cpCategories.length !== 0" class="float-right">
                  <div class="float-right d-flex align-items-center">
                    <div class="mr-3 text-nowrap">Per Page</div>
                    <b-form-select v-model="perPage" :options="pageOptions" />
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </div>
        </b-row>
      </card>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Cookies from 'js-cookie';
import moment from 'moment';
import showConfirmation from '@/utils/mixins/deleteNotify';
import { NotificationTypes, wrapNotification } from '@/utils/notification';

Vue.use(Cookies);

export default {
  name: 'CategoryList',
  mixins: [showConfirmation],
  data: function () {
    return {
      listCollection: [],
      errorFields: [],
      cpCategories: [],
      searchRequest: '',
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      pageOptions: [10, 20, 50, 100],
      allTimeStatus: false,
      selectedFilter: 'all',
      listField: {
        fullname: {
          key: 'category',
          label: 'Category',
          sortable: true,
        },
        group: {
          key: 'group',
          label: 'group',
        },
        date: {
          key: 'dateCreated',
          label: 'date created',
          sortable: true,
        },
        actions: {
          label: 'actions',
        },
      },
      sortBy: 'date',
      sortDesc: true,
      cpCategoriesFilter: [],
      updateAccess: false,
      groupList: [],
      selectedGroupItemsLength: [],
      changedLength: true,
      removedGroupItems: [],
      groupForCategories: [],
    };
  },
  computed: {
    loading() {
      return this.$store.state.contentProvider.categoryLoading;
    },
    currentUserID: {
      get: function () {
        return this.$store.state.user.userID;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    ListFields: {
      get: function () {
        return this.listField;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    selectedCompany: {
      get: function () {
        let selectedCompany = this.$store.state.company.selectedCompany || Cookies.get('companyID');
        return selectedCompany;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    selectedGroupItems: {
      get: function () {
        return [];
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  watch: {},
  mounted() {
    this.loadCPCategories(this.currentPage);
    this.loadCPGroups();
  },
  methods: {
    openCategoryForm() {
      let companyID = Cookies.get('companyID') || '';
      if (!companyID || companyID === '') {
        this.$swal
          .fire({
            type: 'warning',
            position: 'center',
            imageWidth: 150,
            title: 'Organization is Required',
            html: 'Please select organization from the dropdown first located in upper left of the screen in order to create content provider categories',
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: 'Ok',
            confirmButtonClass: 'btn btn-primary pr-5 pl-5',
            footer: '<div class="text-center"> </div>',
            buttonsStyling: false,
            allowOutsideClick: false,
          })
          .then((result) => {});
      } else {
        this.$router.push('/content-provider/categories/create');
      }
    },
    loadCPCategories(currentPage) {
      const companyID = Cookies.get('companyID');
      if (companyID) {
        this.$store.dispatch('contentProvider/GET_CP_CATEGORIES', companyID).then((resp) => {
          this.cpCategories = this.$store.state.contentProvider.cpCategories;
          this.totalRows = this.cpCategories.length;
          if (companyID === undefined) {
            // this.ListFields.companyID = {key: 'companyID', label: 'Company ID', sortable: true}
            this.listField = {
              fullname: {
                key: 'category',
                label: 'Category',
                sortable: true,
              },
              group: { key: 'group', label: 'group' },
              companyID: {
                key: 'companyID',
                label: 'Company ID',
                sortable: true,
              },
              date: {
                key: 'dateCreated',
                label: 'date created',
                sortable: true,
              },
              actions: { label: 'actions' },
            };
          }

          this.cpCategories.map((value) => {
            this.selectedGroupItems[value.actions.id] = [];
            if (value.cpGroups.length > 0) {
              for (var i = 0; i < value.cpGroups.length; i++) {
                this.selectedGroupItems[value.actions.id].push(value.cpGroups[i]._id);
              }
            }
            this.selectedGroupItemsLength[value.actions.id] = this.selectedGroupItems[value.actions.id].length;
          });
        });
      }
    },
    loadCPGroups() {
      const companyID = Cookies.get('companyID');
      if (companyID) {
        this.$store.dispatch('contentProvider/GET_CP_GROUPS', companyID).then((resp) => {
          this.groupForCategories = this.$store.state.contentProvider.cpGroups;
          var groups = this.groupForCategories;
          if (groups.length > 0) {
            for (var key in groups) {
              this.groupList.push({
                id: groups[key]._id,
                createdBy: groups[key].createdBy,
                groupName: groups[key].group,
              });
            }
            if (this.groupList.length > 0) {
              this.groupList = this.groupList.sort((a, b) => a.groupName.localeCompare(b.groupName));
            }
          }
        });
      }
    },
    getGroupList(groupCount) {
      this.$root.$emit('bv::show::modal', `groupInfo${groupCount}`);
    },
    checkGroupIfExist(selectedGroup, groupID) {
      let included = Vue.lodash.filter(selectedGroup, { _id: groupID });
      return included.length > 0;
    },
    getGroups(categoryCurrentGroups) {
      if (categoryCurrentGroups.length > 0) {
        var categoryGroups = [];
        var selectedGroups = [];

        if (this.groupList.length > 0) {
          this.groupList.map((channelGroup) => {
            categoryGroups.push(channelGroup.id);
          });

          categoryCurrentGroups.map((group) => {
            if (categoryGroups.includes(group._id)) {
              selectedGroups.push({
                name: group.group,
                id: group._id,
              });
            }
          });
          selectedGroups.sort((a, b) => a.name.localeCompare(b.name));
          return selectedGroups;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    getGroupNames(groupIDs) {
      if (groupIDs.length > 0) {
        var groupNames = [];
        groupIDs.map((group) => {
          groupNames.push(group.group);
        });
        return groupNames.join('<br/>');
      }

      return '';
    },
    selectGroup(currentChannelCategory, value) {
      let currentGroupCount = this.selectedGroupItems[currentChannelCategory].length;
      let included = this.selectedGroupItems[currentChannelCategory].includes(value);

      if (included) {
        let index = this.selectedGroupItems[currentChannelCategory].indexOf(value);
        if (index > -1) {
          this.selectedGroupItems[currentChannelCategory].splice(index, 1);
        }
        this.removedGroupItems.push(value);
      } else {
        this.selectedGroupItems[currentChannelCategory].push(value);
      }

      if (currentGroupCount !== this.selectedGroupItems[currentChannelCategory].length) {
        this.changedLength = false;
      }
    },
    processUserGroup(id) {
      this.closeGroupModal();
      const categoryID = String(id).trim();
      const formData = {
        cpGroups: this.selectedGroupItems[categoryID],
        removedGroups: this.removedGroupItems,
      };

      this.$store
        .dispatch('contentProvider/UPDATE_CP_CATEGORY_GROUP', {
          formData,
          categoryID,
        })
        .then((res) => {
          if (res.data.success) {
            let message = '';
            if (Number(this.selectedGroupItems[categoryID].length) > this.selectedGroupItemsLength[categoryID]) {
              message = 'User successfully added to group(s)';
            } else {
              message = 'User successfully removed from selected group(s)';
            }
            wrapNotification(this.$notify, NotificationTypes.Success, this.$options.filters.capitalizeWords(message));
            this.removedGroupItems = [];
            this.loadCPCategories(this.currentPage);
          } else {
            wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('Error adding user to group(s)'));
          }
        })
        .catch((err) => {
          console.error(err);
          err.then((error) => {
            wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
            this.hasError = true;
          });
        });
    },
    closeGroupModal() {
      this.$refs['groupModal'].hide();
      this.changedLength = true;
    },
    onSearch(filteredItems) {
      this.$nextTick(() => {
        this.errorFields = [];
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      });
    },
    updateCurrentPage(currentPage) {
      this.errorFields = [];
      this.currentPage = currentPage;
    },
    deleteProcess(id, item) {
      const categoryID = String(id).trim();
      const itemString = `<strong>${item}</strong> category`;
      this.showConfirmation(this.deleteCategory, categoryID, itemString);
    },
    deleteCategory(categoryID) {
      this.$store
        .dispatch('contentProvider/DELETE_CP_CATEGORY', categoryID)
        .then((res) => {
          if (res.data.success) {
            wrapNotification(this.$notify, NotificationTypes.Success, this.$options.filters.capitalizeWords('Category successfully deleted'));
            this.loadCPCategories(this.currentPage);
          } else {
            wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('Error deleting category'));
          }
        })
        .catch((err) => {
          console.error(err);
          err.then((error) => {
            wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
            this.hasError = true;
          });
        });
    },
  },
};
</script>
<style lang="scss">
.table .thead-light .hdcolor {
  color: #536c79 !important;
}

.transaction-error {
  font-size: 0.68rem;
}

a.btn-outline-danger:hover {
  color: #fff !important;
}

a.btn-outline-vobo:hover {
  color: #fff !important;
}

a.btn-outline-default:hover {
  color: #fff !important;
}

a.btn-outline-primary:hover {
  color: #fff !important;
}

.categoryTable td a {
  margin-right: 0.25rem !important;
}

.categoryTable td a:last-child {
  margin-right: 0 !important;
}

.categoryTable .table td {
  padding: 0.7rem 1.5rem;
}

.categoryTable tr {
  th {
    text-align: center;
  }

  &:focus {
    outline: 0 !important;
    outline: none !important;
  }
}

.categoryTable tr th:first-child,
.categoryTable tr td:first-child {
  width: 20% !important;
}

.categoryTable tr th:nth-child(2),
.categoryTable tr td:nth-child(2) {
  width: 20% !important;
  text-align: center;
}

.categoryTable tr th:nth-child(3),
.categoryTable tr td:nth-child(3) {
  width: 20% !important;
  text-align: center;
}

.categoryTable tr th:nth-child(4),
.categoryTable tr td:nth-child(4) {
  width: 20% !important;
  text-align: center;
}

.categoryTable tr th:nth-child(5),
.categoryTable tr td:nth-child(5) {
  width: 20% !important;
  text-align: center;
}

.target-fade-cancel {
  -webkit-animation: target-fade-cancel 2s 1;
  -moz-animation: target-fade-cancel 2s 1;
}

.swal2-icon {
  width: 3.5em !important;
  height: 3.5em !important;
  margin: 0.5em auto 1em !important;
}

.swal2-icon::before {
  font-size: 2.5em !important;
}
</style>
